import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/Auth/PrivateRoute';
import AdminRoute from './components/Auth/AdminRoute';
import SuperAdminRoute from './components/Auth/SuperAdminRoute';
import RoleBasedRoute from './components/Auth/RoleBasedRoute';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminCustomerPage from './pages/AdminCustomerPage';
import ReportsPage from './pages/ReportsPage';
import SecretAnalyticsPage from './pages/SecretAnalyticsPage';
import PasswordMigrationPage from './pages/PasswordMigrationPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import PasswordChangeGate from './components/Auth/PasswordChangeGate';
import TermsConditionsGate from './components/Auth/TermsConditionsGate';
import SignInSetupGate from './components/Auth/SignInSetupGate';
import TermsConditionsPage from './pages/TermsConditionsPage';
import ManageUsersPage from "./pages/ManageUsersPage";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/terms" element={<TermsConditionsPage />} />

        {/* Protected routes - require authentication */}
        <Route path="/" element={<PrivateRoute />}>
          <Route index element={<RoleBasedRoute />} />
        </Route>

        <Route path="/dashboard" element={<PrivateRoute />}>
          <Route
            index
            element={
              <PasswordChangeGate>
                <TermsConditionsGate>
                  <SignInSetupGate>
                    <DashboardPage />
                  </SignInSetupGate>
                </TermsConditionsGate>
              </PasswordChangeGate>
            }
          />
          <Route path="change-password" element={<ChangePasswordPage />} />
        </Route>

        {/* Admin routes */}
        <Route path="/admin" element={<AdminRoute />}>
          <Route
            index
            element={
              <PasswordChangeGate>
                <TermsConditionsGate>
                  <AdminDashboardPage />
                </TermsConditionsGate>
              </PasswordChangeGate>
            }
          />
          <Route
            path="customer/:id"
            element={
              <PasswordChangeGate>
                <TermsConditionsGate>
                  <AdminCustomerPage />
                </TermsConditionsGate>
              </PasswordChangeGate>
            }
          />
          <Route
            path="super"
            element={
              <SuperAdminRoute>
                <Navigate to="/admin/manage-users?tab=admins" replace />
              </SuperAdminRoute>
            }
          />
          <Route
            path="manage-users"
            element={
              <PasswordChangeGate>
                <TermsConditionsGate>
                  <ManageUsersPage />
                </TermsConditionsGate>
              </PasswordChangeGate>
            }
          />
          <Route
            path="reports"
            element={
              <PasswordChangeGate>
                <TermsConditionsGate>
                  <ReportsPage />
                </TermsConditionsGate>
              </PasswordChangeGate>
            }
          />
          <Route
            path="secret-analytics"
            element={
              <PasswordChangeGate>
                <TermsConditionsGate>
                  <SecretAnalyticsPage />
                </TermsConditionsGate>
              </PasswordChangeGate>
            }
          />
          <Route
            path="test-user"
            element={
              <Navigate to="/admin/manage-users?tab=test-user" replace />
            }
          />

          <Route
            path="password-migration"
            element={
              <SuperAdminRoute>
                <PasswordChangeGate>
                  <TermsConditionsGate>
                    <PasswordMigrationPage />
                  </TermsConditionsGate>
                </PasswordChangeGate>
              </SuperAdminRoute>
            }
          />
        </Route>

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
